'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var getThemeProp = require('../utils/getThemeProp.js');
require('../utils/colors.js');
require('../utils/dates.js');
require('../utils/numbers.js');
require('../utils/PrintComponentGenerator/PrintComponentGenerator.js');
require('../utils/strings.js');
require('../utils/infiniteScrollCheckStateManager/infiniteScrollCheckStateManager.js');
require('../utils/pairedTableComponentGenerator/pairedTableComponentGenerator.js');
require('../utils/safeFetch.js');
require('../utils/dom.js');

var ColoredDiv = styled__default.div(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  background-color: ", ";\n  height: 100%;\n  padding: 1rem;\n"], ["\n  background-color: ", ";\n  height: 100%;\n  padding: 1rem;\n"])), getThemeProp('palette.background.default'));
var templateObject_1;

exports.ColoredDiv = ColoredDiv;
